// extracted by mini-css-extract-plugin
export default {"container":"styles_container__znNca","title":"styles_title__gLh+M","description":"styles_description__owUOV","descriptionCenter":"styles_descriptionCenter__3WyZn"};